import { UpdateStatus } from "app/data/terminal-details/models";

export interface UpdateStatusState {
    data: UpdateStatus | null;  
    isLoading: boolean;
    isSuccess: boolean;
    isError: boolean;
    errorMessage?: string | null;
}

export const initialUpdateStatusState: UpdateStatusState = {
    data: null,
    isLoading: false,
    isSuccess: false,
    isError: false,
    errorMessage: null
};
  